import React, { useState, useRef, useEffect } from "react";
import SearchBox from './SearchBox/SearchBox';
import SearchTable from './SearchTable/SearchTable';
import { SearchFilterTableProvider } from "../../context/SearchFilterTableContext";
import { useSearchParams, useSearchParamsDispatch } from "../../context/SearchParamsContext";


const SearchPage = (props) => {
    const [showCalendar, setShowCalendar] = useState(false);
    const [filterNumber, setFilterNumber] = useState(false);
    const { searchResults } = useSearchParams();
    const searchParamsDispatch = useSearchParamsDispatch();
    const listRef = useRef(null);

    useEffect(() => {
      if (listRef?.current !== 'null' && searchResults?.length > 0) {
        window.scrollTo(0, window.scrollY);
      };
    }, [listRef, searchResults]);

    const onHandleFilter = (event) => {
      setTimeout(() => {setFilterNumber(filterNumber+1);},0);
      searchParamsDispatch({ queryFilters: event });
      const keys = Object.keys(event);
      const val = Object.values(event);
      const index = keys.indexOf("querySearch");
      const indext = keys.indexOf("tipo");
      let query = '';
    
      let producto =''
       if( index !== -1) {
        query = val[index];
       }
       if( indext !== -1) {
        producto = val[indext];
       }
    
       let event1 = {
        "event": "en_search",
        "ep_view_name": "Buscador",
        "ep_user_id": "",
        "ep_user_type": "",
        "ep_action_detail": "Buscar", 
        "ep_keyword": query,
        "ep_filter_type":"Producto",
        "ep_filter_selection": producto
        };

      window.dataLayer.push(event1)
    }

    return (
      <SearchFilterTableProvider>
        <div ref={listRef} data-testid="pagina-buscador" className="app" onClick={(e) => {
            if((!e.target.classList.value.includes('react-calendar') && !e.target.parentElement.classList.value.includes('react-calendar')) && showCalendar) {
              setShowCalendar(false);
            }}}>
          <section className="wrapper-search justify-content-center" style={{paddingBottom: 50}}>
            <div className='container'>
              <SearchBox
                onHandleFilter={onHandleFilter}
              />
            </div>
          </section>
          
          {/* {searchResults?.length > 0 && ( */}
            <SearchTable
              setSelectedProduct={props.setSelectedProduct}
              startComparing={props.startComparing}
              filterNumber={filterNumber}
            />
          {/* )} */}
        </div>
      </SearchFilterTableProvider>
    );
};

export default SearchPage;
